<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M8.875 15.25L12.3679 9.42849C12.8145 8.68419 13.9 8.70459 14.3183 9.46514L16.5831 13.5828C16.9954 14.3326 16.453 15.25 15.5973 15.25H10H4.30225C3.47033 15.25 2.92618 14.3783 3.29156 13.6309L7.05984 5.92305C7.45786 5.10893 8.60588 5.07543 9.05068 5.86496L11.75 10.6562" 
    stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'PeakIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>